function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "delivery-truck",
  transform: "translate(0 -62.812)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11468",
  "data-name": "Group 11468",
  transform: "translate(2.178 71.374)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11467",
  "data-name": "Group 11467",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18950",
  "data-name": "Path 18950",
  d: "M65.539,311.112a2.381,2.381,0,1,0,2.381,2.381A2.383,2.383,0,0,0,65.539,311.112Z",
  transform: "translate(-63.158 -311.112)",
  fill: "#adafb3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_11470",
  "data-name": "Group 11470",
  transform: "translate(10.71 71.374)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11469",
  "data-name": "Group 11469",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18951",
  "data-name": "Path 18951",
  d: "M312.981,311.112a2.381,2.381,0,1,0,2.381,2.381A2.383,2.383,0,0,0,312.981,311.112Z",
  transform: "translate(-310.6 -311.112)",
  fill: "#adafb3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_11472",
  "data-name": "Group 11472",
  transform: "translate(0 65.426)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11471",
  "data-name": "Group 11471",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18952",
  "data-name": "Path 18952",
  d: "M2.155,138.63A2.157,2.157,0,0,0,0,140.785v5.477a1.215,1.215,0,0,0,1.214,1.214h.069a3.318,3.318,0,0,1,2.759-3.793V138.63H2.155Z",
  transform: "translate(0 -138.63)",
  fill: "#adafb3"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_11474",
  "data-name": "Group 11474",
  transform: "translate(5.075 62.812)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11473",
  "data-name": "Group 11473"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_18953",
  "data-name": "Path 18953",
  d: "M158.4,62.812h-9.829a1.377,1.377,0,0,0-1.375,1.375v6.291a3.317,3.317,0,0,1,2.759,3.793h1.981a3.316,3.316,0,1,1,6.552,0A1.377,1.377,0,0,0,159.77,72.9V64.187A1.377,1.377,0,0,0,158.4,62.812Z",
  transform: "translate(-147.191 -62.812)",
  fill: "#adafb3"
}))));

function SvgLiveTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.655,
    height: 13.323,
    viewBox: "0 0 17.655 13.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTracking);
export default __webpack_public_path__ + "static/media/live-tracking.832907a1.svg";
export { ForwardRef as ReactComponent };